import { PNotifyService } from './../../../services/pnotify.service';
import { AuthService } from './../../../services/auth.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Responsible } from '../../../models/responsible';
import { Select2OptionData } from 'ng2-select2';
import * as moment from 'moment';

@Component({
  selector: 'app-responsible-edit',
  templateUrl: './responsible-edit.component.html',
  styleUrls: ['./responsible-edit.component.css']
})
export class ResponsibleEditComponent implements OnInit {

  responsible: Responsible;
  passwordChange = {
    enabled: false,
    password: '',
    passwordConfirm: ''
  };
  showCurrentPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  isAccountPage: boolean;
  reservedUsernames: string[];
  pack: Array<Select2OptionData>;
  pnotify = undefined;
  clients: any[];
  schools: any[];
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    pnotifyService: PNotifyService
  ) {
    this.responsible = new Responsible();
    this.reservedUsernames = [];
    this.pack = [
      { id: '', text: 'Choisir un type' },
      { id : '1', text: 'Start' },
      { id : '2', text: 'Essentiel' },
      { id : '3', text: 'Pro' },
    ];
    this.isAccountPage = (this.router.url.indexOf('/account') === 0);
    this.route.params.subscribe(params => {
      const id = this.isAccountPage ? this.authService.getUser().id : params['id'];
      this.http.get(
        '/api/responsible/' + id
      ).subscribe((responsible: Responsible) => {
        this.responsible = responsible;
        this.pack = this.pack.map((data, index) => {
          return {
            id: data.id,
            text: data.text,
            selected: (data.id == responsible.pack) ? true : false
           };
        });
        $('#image-cropper').cropit('imageSrc', this.responsible.image);
        this.http.get(
          '/api/responsible/reservedUsernames/' + id
        ).subscribe((usernames: any[]) => {
          for (let i = 0; i < usernames.length; i++) {
            this.reservedUsernames.push(usernames[i].username);
          }
        });
        this.http.get(
          '/api/client/lookup'
        ).subscribe((clients: any[]) => {
          this.clients = clients;
          const array1 = [{ id: '', text: 'Choisir un client' }];
          const array2 = this.clients.map((client, index) => {
            return { id: client.id, text: client.name, selected: (client.id == this.responsible.School.clientId) ? true : false };
          });
          this.clientsData = array1.concat(array2);
        });
      });
    });
    this.pnotify = pnotifyService.getPNotify();

  }

  ngOnInit() {
    $('#image-cropper').cropit({
      allowDragNDrop: false,
      smallImage: 'allow',
      imageSrc: 'assets/images/user.png'
    });
    $('.select-image-btn').click(function () {
      $('.cropit-image-input').click();
    });
  }

  clientChanged(e: any) {
    const params = new HttpParams({
      fromObject: {
        clientId: e.value + ''
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = schools.map((school, index) => {
        return { id: school.id, text: school.name, selected: (school.id == this.responsible.schoolId) ? true : false };
      });
      this.schoolsData = array1.concat(array2);
    });
  }

  schoolChanged(e: any) {
    this.responsible.schoolId = e.value;
  }
  onUsernameChange() {
    this.responsible.username = this.responsible.username.replace(/\s/g, '');
  }

  packChanged(e: any) {
    this.responsible.pack = e.value;
  }

  onSubmit(): void {
    this.responsible.expiration = moment(this.responsible.expiration).format('YYYY-MM-DD HH:mm:ss');
    this.responsible.lastConnection = moment(this.responsible.lastConnection).format('YYYY-MM-DD HH:mm:ss');
    const previewSize = $('#image-cropper').cropit('previewSize');
    const quality = previewSize.width > 100 ? 100 / previewSize.width : 1;
    if ($('#image-cropper').cropit('imageSrc')) {
      this.responsible.image = $('#image-cropper').cropit('export', {
        type: 'image/jpeg',
        smallImage: 'allow',
        quality: quality,
        fillBg: '#fff',
        originalSize: false
      });
    }
    this.http.put(
      '/api/responsible/' + this.responsible.id,
      {
        responsible: this.responsible,
        passwordChange: this.passwordChange
      }
    ).subscribe(
      (responsible: Responsible) => {
        this.responsible = responsible;
        this.router.navigate(this.isAccountPage ? ['/account/responsible/view'] : ['/responsible/view', this.responsible.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/responsible/responsible-edit/responsible-edit.component.ts